//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "ImageZoom",
  props: {
    src: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      backgroundPosition: 'unset',
      backgroundSize: 'contain'
    }
  },
  methods: {
    mousemove(event) {
      var dimentions = this.$refs.zoom.getBoundingClientRect();

      // Calculate the position of the cursor inside the element (in pixels).
      var x = event.clientX - dimentions.left;
      var y = event.clientY - dimentions.top;

      // Calculate the position of the cursor as a percentage of the total size of the element.
      var xpercent = Math.round(100 / (dimentions.width / x));
      var ypercent = Math.round(100 / (dimentions.height / y));

      // Update the background position of the image.
      this.backgroundPosition = xpercent+'% ' + ypercent+'%';
        console.log("Position", event.clientX, event.clientY, this.$refs.zoom.getBoundingClientRect())
    },
    mouseenter() {
      this.backgroundSize = "250%";
    },
    mouseleave() {
      this.backgroundSize = "contain";
      this.backgroundPosition = "unset";
    }
  }
}
